export * from './zeit-detail.component';
export * from './zeit-detail.component.module';